import { render, staticRenderFns } from "./MyRequestsTable.vue?vue&type=template&id=6971f330&scoped=true"
import script from "./MyRequestsTable.vue?vue&type=script&lang=ts"
export * from "./MyRequestsTable.vue?vue&type=script&lang=ts"
import style0 from "./MyRequestsTable.vue?vue&type=style&index=0&id=6971f330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6971f330",
  null
  
)

export default component.exports